import { useEffect, useState } from 'react';
import axios from 'axios';

const useBackendStatus = (url = 'https//api.monkeybox.ai/api/health', intervalMs = 10000) => {
  const [status, setStatus] = useState(null); // true = ok, false = down

  useEffect(() => {
    const checkConnection = async () => {
      try {
        await axios.get(url);
        setStatus(true);
      } catch {
        setStatus(false);
      }
    };

    checkConnection(); // initial check
    const interval = setInterval(checkConnection, intervalMs);

    return () => clearInterval(interval);
  }, [url, intervalMs]);

  return status;
};

export default useBackendStatus;
